define('Magento_Catalog/js/view/compare-products-mixin',[
    'jquery',
    'ko',
    'Magento_Catalog/js/action/compare'
], function ($, ko, compareAction) {
    'use strict';

    var mixin = {

        toggleBtn: ko.observable(false),

        /**
         * Filter phones specification details
         * @param event
         */
        showDifferences: function (event) {
            (this.toggleBtn) ? this.toggleBtn(false) : this.toggleBtn(true);
            this.toggleBtn(true);
            compareAction.clickShowDifferencesBtn(event);
        },

        /**
         * Redirect customer back to previous page, or on PLP anchor to the product list
         * @param event
         */
        backLink: function (event) {
            event.preventDefault();
            if ($('body').hasClass('page-products')) {
                $('html, body').animate({
                    scrollTop: $("#maincontent").offset().top
                }, 500);
            } else {
                window.history.back();
            }
        }
    };

    return function (target) {
        return target.extend(mixin);
    };
});

